<template>
    <div class="buildStore-main">
        <div class="left-process">
            <div class="process-block" v-for="item in processList">
                <h4>{{ item.title }}</h4>
                <div class="process-box">
                    <div class="process-item" v-for="item2 in item.list">
                        <p :class="currentIndex === item2.id ? 'checked' : ''" @click="changeIndex(item2.id)">
                            {{ item2.name }}</p>
                        <div class="pt" v-if="currentIndex === item2.id"></div>
                        <i class="iconfont icon2-check ic" v-if="item2.finished"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-cont">
            <EditStore ref="editStore" v-if="currentIndex === 1"></EditStore>
            <OfficialWebsite ref="officialWebsite" v-if="currentIndex === 2"></OfficialWebsite>
            <ServiceSettings ref="serviceSettings" v-if="currentIndex === 3"></ServiceSettings>
            <DeskManage ref="deskManage" v-if="currentIndex === 4"></DeskManage>
            <Cashier ref="cashier" v-if="currentIndex === 5"></Cashier>
            <Kitchen ref="kitchen" v-if="currentIndex === 6"></Kitchen>
            <GoodsClassify ref="goodsClassify" v-if="currentIndex === 7"></GoodsClassify>
            <AddGoods ref="addGoods" v-if="currentIndex === 8"></AddGoods>
            <TaxRate ref="rateSetting" v-if="currentIndex === 9"></TaxRate>
            <WebsiteEdit ref="websiteEdit" v-if="currentIndex === 10"></WebsiteEdit>
            <Article ref="article" v-if="currentIndex === 11"></Article>

<!--            <ThemeEdit ref="themeEdit" v-if="currentIndex === 8"></ThemeEdit>-->
<!--            <MyMenu ref="myMenu" v-if="currentIndex === 9"></MyMenu>-->
            <div class="footer">
              <el-button size="small" type="primary" @click="setStep(-1)" :loading="loading1" v-if="currentIndex > 1">{{ $t('上一步') }}</el-button>
              <el-button size="small" type="primary" @click="saveStep(1)" :loading="saveLoading" v-if="shouldSaveList.includes(currentIndex)" :disabled="currentIndex >= stepNameList.length">{{ $t('保存') }}</el-button>
              <el-button size="small" type="primary" @click="setStep(1)" :loading="loading2" v-if="currentIndex < stepNameList.length">{{ $t('下一步') }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import buildstoreApi from "@/api/buildstore";

import EditStore from "../basicInfo/editStore";
import OfficialWebsite from "../basicInfo/officialWebsite";
import ServiceSettings from "../services/serviceSettings";
import DeskManage from "../services/deskManage/index";
import Cashier from "../services/cashier/index";
import Kitchen from "../services/kitchen/index";
import GoodsClassify from '../goods/goodsClassify/index';
import AddGoods from "../goods/addGoods/index";
import WebsiteEdit from "../website/websiteEdit/index";
import Article from '../website/article/index';
import TaxRate from '../goods/taxRate/index';

export default {
    name: "index",
    components: {
        EditStore, OfficialWebsite, ServiceSettings, DeskManage, GoodsClassify, AddGoods, WebsiteEdit, Article, Cashier, Kitchen,TaxRate
    },
    data() {
        return {
            currentIndex: 1,
            loading1: false,
            loading2: false,
            saveLoading: false,
            stepNameList: ['editStore', 'officialWebsite', 'serviceSettings', 'deskManage', 'cashier', 'kitchen', 'goodsClassify', 'addGoods','rateSetting', 'websiteEdit', 'article'],
            shouldSaveList: [1, 2, 3, 10],
            processList: [
                {
                    title: this.$t('基本资料'),
                    list: [
                        {
                            name: this.$t('商家信息'),
                            alias: 'supplierEdit',
                            id: 1,
                            finished: false
                        },
                        {
                            name: this.$t('网址设置'),
                            alias: 'website',
                            id: 2,
                            finished: false
                        },
                    ]
                },
                {
                    title: this.$t('门店服务'),
                    list: [
                        {
                            name: this.$t('服务与营业时间'),
                            alias: 'supplierSetting',
                            id: 3,
                            finished: false
                        },
                        {
                            name: this.$t('桌码管理'),
                            alias: 'storeTable',
                            id: 4,
                            finished: false
                        },
                        {
                            name: this.$t('收银台'),
                            alias: 'cashier',
                            id: 5,
                            finished: false
                        },
                        {
                            name: this.$t('后厨'),
                            alias: 'kitchen',
                            id: 6,
                            finished: false
                        }
                    ]
                },
                {
                    title: this.$t('菜品'),
                    list: [
                        {
                            name: this.$t('菜品分类'),
                            alias: 'productCategory',
                            id: 7,
                            finished: false
                        },
                        {
                            name: this.$t('添加菜品'),
                            alias: 'productAdd',
                            id: 8,
                            finished: false
                        },
                        {
                            name: this.$t('税率设置'),
                            alias: 'rateSetting',
                            id: 9,
                            finished: false
                        },
                    ]
                },
                {
                    title: this.$t('网站'),
                    list: [
                        {
                            name: this.$t('手机网站编辑'),
                            alias: 'pageHome',
                            id: 10,
                            finished: false
                        },
                        {
                            name: this.$t('通告'),
                            alias: 'article',
                            id: 11,
                            finished: false
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        changeIndex(index) {
            this.currentIndex = index
            this.$emit('changeStep')

            this.$router.push({
                query: {
                    step: this.currentIndex
                }
            })
        },
        async saveStep(step){
          if (step > 0) {
            this.saveLoading = true
          }
          let ret = await this.$refs[this.stepNameList[this.currentIndex - 1]].onSubmit()
          if (ret === 0) {
            this.$message({
              type: 'success',
              message: '数据已保存'
            })
          }else {
            if (ret === 2) {
              this.$message({
                type: 'error',
                message: this.$t('提交失败')
              })
            }
          }
          this.saveLoading = false
        },
        async setStep(step) {
            if (step > 0) {
                this.loading2 = true
            } else if (step < 0) {
                this.loading1 = true
            }
            // 0提交成功 1表单不完整 2提交失败
            let ret = await this.$refs[this.stepNameList[this.currentIndex - 1]].onSubmit()
            if (ret === 0) {
                if (this.currentIndex + step >= 1 && this.currentIndex + step <= this.stepNameList.length) {
                    this.changeIndex(this.currentIndex + step)
                    // this.currentIndex = this.currentIndex + step
                }
            } else {
                if (ret === 2) {
                    this.$message({
                        type: 'error',
                        message: this.$t('提交失败')
                    })
                }
            }
            this.loading1 = false
            this.loading2 = false
        },
        async getProgress() {
            let res = await buildstoreApi.getProgress({}, true)
            if (res && res.code === 1) {
                if (res.data && res.data.stepStatus) {
                    this.processList.forEach((subList) => {
                        subList.list.forEach((item) => {
                            let status = res.data.stepStatus[item.alias]
                            status = Boolean(status)
                            item.finished = status
                        })
                    })
                }
            } else {
                this.$message({
                    message: this.$t('获取当前进度信息失败'),
                    type: 'error'
                })
            }
        }
    },
    watch: {
        currentIndex: {
            handler: async function () {
                await this.getProgress()
            },
            immediate: false
        }
    },
    async created() {
        this.currentIndex = this.$route.query.step ? Number(this.$route.query.step) : 1
        await this.$router.push({
            query: Object.assign(this.$route.query, {
                step: this.currentIndex
            })
        })

        await this.getProgress()
    }
}
</script>

<style scoped lang="scss">
.buildStore-main {
    display: flex;
    justify-content: left;
    height: 100%;
    width: 100%;

    .process-block:not(:first-child) {
        margin-top: 15px;
    }

    .right-cont {
        height: auto;
        flex: auto;

        .footer {
            margin: 15px 0;
            display: flex;
            justify-content: center;
        }
    }

    .left-process {
        width: 200px;
        height: 100%;
        flex-shrink: 0;
        /*background-color: #00a0e9;*/

        h4 {
            font-size: 20px;
            color: #3F3F3F;
        }

        .process-box {
            margin-top: 12px;
            border-left: 1px solid #f1f1f1;
            width: 100%;

            .process-item {
                box-sizing: border-box;
                width: 100%;
                padding: 10px 15px;
                position: relative;
                display: flex;
                justify-content: space-between;

                .checked {
                    color: #f07b00;
                }

                .pt {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 12px;
                    height: 12px;
                    border-radius: 8px;
                    background-color: #f07b00;
                    transform: translate(-50%, -50%);
                }

                p {
                    font-size: 16px;
                    color: #3F3F3F;
                    position: relative;
                    cursor: pointer;
                }

                .ic {
                    color: #80c784;
                    font-size: 16px;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/buildstore/index/index.vue